import { Link } from "react-router-dom";

export default function Footer() {
  const links = [
    { label: "About", path: "/about" },
    { label: "Terms", path: "/terms" },
    { label: "Privacy", path: "/privacy" },
    { label: "FAQ", path: "/faq" },
    { label: "Feedback", path: "/feedback" },
    { label: "Help", path: "/help" },
    { label: "Contact Us", path: "/contact" },
  ];
  return (
    <footer style={{ background: "#2C2C2C", borderTop: "2px solid #C9A84C", padding: "28px 48px", marginTop: "auto" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ background: "#C9A84C", width: "30px", height: "30px", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "15px", color: "#2C2C2C", fontStyle: "italic" }}>T</div>
          <span style={{ color: "white", fontWeight: 700, fontSize: "16px" }}>Tax<span style={{ color: "#C9A84C" }}>Thinker</span></span>
        </div>
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          {links.map(item => (
            <Link key={item.path} to={item.path}
              style={{ color: "#909090", fontSize: "13px", transition: "color 0.2s" }}
              onMouseEnter={e => { e.currentTarget.style.color = "#C9A84C"; }}
              onMouseLeave={e => { e.currentTarget.style.color = "#909090"; }}>
              {item.label}
            </Link>
          ))}
        </div>
        <div style={{ color: "#606060", fontSize: "12px" }}>
          2026 TaxThinker. Built for Chartered Accountants in India.
        </div>
      </div>
    </footer>
  );
}
